// extracted by mini-css-extract-plugin
module.exports = {"instructionsPage":"InstructionsPage_instructionsPage__ds8JM"};